import { css } from '@compiled/react';
import PropTypes from 'prop-types';

import { wacToken } from '@/libraries/design/foundations';

export type UniformHorizontalDividerProps = {
	lineStyle?: 'solid' | 'dotted';
};

const dividerStyle = css({
	width: '100%',
	border: 'none',
	margin: 0,
});

const UniformHorizontalDivider = ({ lineStyle = 'solid' }: UniformHorizontalDividerProps) => {
	return (
		<hr
			css={dividerStyle}
			role="presentation"
			style={{
				borderBlockStart: `1px ${lineStyle} ${wacToken('color.neutral.light400')}`,
			}}
		/>
	);
};

UniformHorizontalDivider.propTypes = {
	lineStyle: PropTypes.string,
};

export default UniformHorizontalDivider;
